import { motion } from "framer-motion";
// import { Link} from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
// import industries from "../../Data/industries"; 
import industries from "./IndustryData_lp";

const IndustriesPage = () => {
const ctaColor = {
  color: 'rgb(59, 130, 246)', 
  accent: 'rgb(37, 99, 235)'}

  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-br from-gray-900 to-gray-950">
      {/* Animated background elements */}
      <div className="fixed inset-0 overflow-hidden -z-10">
        <motion.div 
          animate={{
            x: [0, 100, 0],
            y: [0, -50, 0],
          }}
          transition={{
            duration: 30,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/10 rounded-full filter blur-3xl"
        ></motion.div>
        <motion.div
          animate={{
            x: [0, -100, 0],
            y: [0, 50, 0],
          }}
          transition={{
            duration: 40,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-purple-500/10 rounded-full filter blur-3xl"
        ></motion.div>
      </div>

      {/* Hero Section */}
      <section className="relative pt-32 pb-2 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="mb-8"
          >
            <span className="inline-block px-4 py-1.5 text-sm font-semibold tracking-wider text-blue-300 uppercase rounded-full bg-blue-900/30 border border-blue-800/50">
              Industry-Specific Solutions
            </span>
          </motion.div>
          
          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl sm:text-5xl md:text-6xl font-bold mb-6 leading-tight"
          >
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 via-purple-400 to-blue-500 animate-gradient-x">
              Tailored for Your Industry
            </span>
          </motion.h1>
          
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto mb-8"
          >
            Custom digital solutions designed to address the unique challenges and opportunities in your sector
          </motion.p>
          
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex justify-center"
          >
            <div className="w-24 h-1.5 bg-gradient-to-r from-blue-400 via-purple-500 to-blue-400 rounded-full animate-pulse"></div>
          </motion.div>
        </div>
      </section>

      {/* Industries Grid */}
      <section className="relative py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true, margin: "-100px" }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          >
            {Object.values(industries).map((industry, index) => (
              <motion.div
                key={industry.slug}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true, margin: "-50px" }}
                whileHover={{ y: -10 }}
                className="group relative"
              >
                <div 
                  // onClick={() => handleNavigate(industry.slug)}
                  className="relative h-full "
                >
                  {/* Gradient overlay using brand colors */}
                  <div 
                    className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl"
                    style={{
                      background: industry.brand.gradient,
                      mixBlendMode: 'soft-light'
                    }}
                  ></div>
                  
                  {/* Main card with border using brand color */}
                  <div 
                    className="relative h-full bg-gray-800/80 rounded-2xl overflow-hidden shadow-lg group-hover:shadow-xl transition-all duration-500"
                    style={{
                      border: `1px solid ${industry.brand.color}20` // 20% opacity
                    }}
                  >
                    {/* Background accent glow */}
                    <div 
                      className="absolute -inset-2 opacity-0 group-hover:opacity-0 blur-md transition-opacity duration-500"
                      style={{
                        background: industry.brand.color
                      }}
                    ></div>
                    
                    <div className="relative h-full p-8 flex flex-col items-center text-center z-10">
                      {/* Icon with gradient glow */}
                      <div className="relative mb-6">
                        <div 
                          className="absolute inset-0 rounded-full opacity-0 group-hover:opacity-10 blur-md transition-all duration-500"
                          style={{
                            background: industry.brand.color
                          }}
                        ></div>
                        <motion.div
                          whileHover={{ scale: 1.1, rotate: 5 }}
                          className="p-4 rounded-xl inline-flex backdrop-blur-sm border"
                          style={{
                            backgroundColor: `${industry.brand.color}15`,
                            borderColor: `${industry.brand.color}30`
                          }}
                        >
                          <industry.icon.reactIcons 
                            style={{ 
                              color: industry.brand.color 
                            }} 
                            className="text-4xl"
                          />
                        </motion.div>
                      </div>
                      
                      {/* Title with brand color accent */}
                      <h3 
                        className="text-2xl font-bold mb-3"
                        style={{
                          background: `linear-gradient(to right, #fff, ${industry.brand.accent})`,
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent'
                        }}
                      >
                        {industry.title}
                      </h3>
                      
                      <p className="text-gray-300 mb-6">{industry.summary}</p>
                      
                      {/* Segment badge */}
                      <div 
                        className="mb-6 px-3 py-1 text-xs font-medium rounded-full"
                        style={{
                          backgroundColor: `${industry.brand.color}15`,
                          color: industry.brand.accent,
                          border: `1px solid ${industry.brand.color}30`
                        }}
                      >
                        {industry.segment}
                      </div>
                      
                      {/* Stats highlights */}
                      {/* <div className="grid grid-cols-3 gap-2 w-full mb-6">
                        {industry.hero.highlights.map((highlight, i) => (
                          <div 
                            key={i}
                            className="p-2 rounded-lg"
                            style={{
                              backgroundColor: `${industry.brand.color}10`,
                              border: `1px solid ${industry.brand.accent}20`,
                            }}
                          >
                            <div 
                              className="text-xl font-bold mb-1"
                              style={{ color: industry.brand.accent }}
                            >
                              {highlight.value}
                            </div>
                            <div className="text-xs text-gray-300">{highlight.label}</div>
                          </div>
                        ))}
                      </div> */}
                      
                      {/* Learn more button */}
                      <div className="mt-auto pt-4 w-full">
                        <a href='#leadForm'>
                        <motion.div
                          whileHover={{ scale: 1.05 }}
                          className="inline-flex items-center justify-center gap-2 px-4 py-2 rounded-full transition-all duration-300"
                          style={{
                            background: `linear-gradient(90deg, ${industry.brand.color}30, ${industry.brand.accent}20)`,
                            border: `1px solid ${industry.brand.color}30`,
                            color: industry.brand.accent
                          }}
                        >
                          <span className="text-sm font-medium">Get a Quote</span>
                          <FiArrowRight />
                        </motion.div></a>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative py-24 px-4 sm:px-6 lg:px-8">
  <div className="max-w-5xl mx-auto">
    

    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="relative rounded-3xl overflow-hidden border shadow-2xl"
      style={{
        background: `linear-gradient(135deg, ${ctaColor.color}10, ${ctaColor.accent}05)`,
        borderColor: `${ctaColor.color}30`
      }}
    >
      {/* Decorative elements */}
      <div 
        className="absolute -top-20 -right-20 w-64 h-64 rounded-full filter blur-3xl animate-pulse opacity-70"
        style={{
          background: ctaColor.color
        }}
      ></div>
      <div 
        className="absolute -bottom-20 -left-20 w-72 h-72 rounded-full filter blur-3xl animate-pulse opacity-70"
        style={{
          background: ctaColor.accent
        }}
      ></div>
      
      {/* Grid pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
      </div>
      
      <div className="relative px-8 py-16 sm:p-20 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6"
          style={{
            background: `linear-gradient(to right, #fff, ${ctaColor.accent})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          Ready to Transform Your Industry Presence?
        </motion.h2>
        
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto"
        >
          Whether you're in a specialized niche or broad sector, we'll craft the perfect digital solution for your needs.
        </motion.p>
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col sm:flex-row justify-center gap-4"
        >
          <a href='#leadForm'>
            <motion.button
              whileHover={{ 
                scale: 1.05,
                boxShadow: `0 10px 25px -5px ${ctaColor.color}40`
              }}
              whileTap={{ scale: 0.98 }}
              className="px-8 py-4 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2"
              style={{
                background: `linear-gradient(to right, ${ctaColor.color}, ${ctaColor.accent})`
              }}
            >
              <span>Get a Custom Quote</span>
              <FiArrowRight className="text-lg" />
            </motion.button>
          </a>
          <a href='#services'>
            <motion.button
              whileHover={{ 
                scale: 1.05,
                backgroundColor: `${ctaColor.color}20`
              }}
              whileTap={{ scale: 0.98 }}
              className="px-8 py-4 bg-transparent border-2 text-white font-bold rounded-xl transition-all duration-300"
              style={{
                borderColor: ctaColor.color
              }}
            >
              View All Services
            </motion.button>
          </a>
        </motion.div>
      </div>
    </motion.div>
  </div>
</section>
    </div>
  );
};

export default IndustriesPage;